<template>
	<div class="loader">
		<div class="loading-text">{{ $t("poweredByFoyrLoader.loading") }}</div>
		<div class="powered-by-wrapper">
			{{ $t("poweredByFoyrLoader.poweredBy") }}
			<img :src="appImages['foyr-logo-with-name.png']" alt="" />
		</div>
	</div>
</template>

<script>
export default {
	name: "PoweredByFoyrLoader",
	components: {},
	props: {},
	data: () => ({}),
	computed: {},
	created() {},
	mounted() {},
	methods: {},
	destroyed() {},
};
</script>

<style lang="scss" scoped>
.loader {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;

	color: color(secondary-white);
	background-color: color(secondary-white);
	font-size: 1.5rem;
	margin-bottom: 1rem;

	.loading-text {
		color: color(primary-purple);
		font-size: 1.25rem;
		font-style: normal;
		font-weight: 700;
		line-height: 1.3402rem;
		text-transform: uppercase;
		margin-bottom: 3.75rem;
	}

	.powered-by-wrapper {
		color: color(primary-text);
		font-size: 1rem;
		font-style: normal;
		font-weight: 400;
		line-height: 1.5rem;

		display: flex;
		align-items: center;

		img {
			margin-left: 14px;
			display: block;
			height: 2.375rem;
			width: 5.5625rem;
		}
	}
}
</style>
